import { Suspense } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/styles';
import { useSelector } from 'react-redux';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LoadingSpinner, NotFound } from 'fni-components-next';
import workbenchTheme from 'fni-theme/WorkbenchTheme';
import { authSelectors } from '../authentication/modules/auth.js';
import FNIContainer from '../container/fni-container';
import AuthenticationRouter from '../authentication/AuthenticationRouter.js';

export default function MigratedRouter() {

    const currentAuthenticatedUser = useSelector(authSelectors.currentAuthenticatedUser);
    const { pathname } = useLocation();

    return (
        <>
            <CssBaseline />
            <ThemeProvider theme={workbenchTheme}>
                <Suspense fallback={ <LoadingSpinner open={true} /> }>
                    <FNIContainer isSearch={pathname.includes('fni-lenderportal-search')} currentAuthenticatedUser={currentAuthenticatedUser}>
                        <Routes>
                            <Route path='auth/*' element={<AuthenticationRouter />} />
                            <Route path='*' element={<NotFound />} />
                        </Routes>
                    </FNIContainer>
                </Suspense>
            </ThemeProvider>
        </>
    );
}
